import {
  TICKET_BODY_MAX_LENGTH,
  TICKET_SUBJECT_MAX_LENGTH,
} from "entities/support-ticket";
import type { CreateTicketRequest } from "entities/support-ticket";

export type TicketField = keyof CreateTicketRequest;
export type TicketErrors = Partial<Record<TicketField, string>>;

const MAX_LENGTHS: Record<TicketField, number> = {
  subject: TICKET_SUBJECT_MAX_LENGTH,
  body: TICKET_BODY_MAX_LENGTH,
};

const validateField = (field: TicketField, value: string) => {
  if (!value.trim()) return "This field is required.";
  if (value.length > MAX_LENGTHS[field]) {
    return `Maximum ${MAX_LENGTHS[field]} characters.`;
  }
  return undefined;
};

export const validateTicket = (values: CreateTicketRequest): TicketErrors => ({
  subject: validateField("subject", values.subject),
  body: validateField("body", values.body),
});

export const hasTicketErrors = (errors: TicketErrors): boolean =>
  Object.values(errors).some(Boolean);
